import { notesFiscalUpdateTypes } from "../../reducers/notesFiscalUpdate/notesFiscalUpdateTypes";
import { notesMigrationTypes } from "../../reducers/notesMigration/notesMigrationTypes";
import { PROYECT, api_post, api_get } from "../../../services/api";
import { startRequestComp, stopRequestComp, setSnackbar } from "../search/searchActions";

const {
  SET_NOTES_FISCAL_UPDATE_FILTERS,
  GET_NOTES_FISCAL_UPDATE,
  SELECT_NOTE_TO_FISCAL_UPDATE,
  DESELECT_NOTE_TO_FISCAL_UPDATE,
  DO_NOTES_FISCAL_UPDATE,
  SELECT_NEXT_NOTES_FISCAL_UPDATE,
  CLEAR_NOTES_FISCAL_UPDATE,
  SET_CONFIG_FILTER_NOTES_FISCAL_UPDATE,
  SET_CONFIG_PAGE_NOTES_FISCAL_UPDATE,
  SET_CONFIG_PAGE_SIZE_NOTES_FISCAL_UPDATE,
  SET_CONFIG_SORTED_NOTES_FISCAL_UPDATE,
} = notesFiscalUpdateTypes;

const { DO_NOTES_MIGRATION } = notesMigrationTypes;

export const getAllNotesFiscalUpdate = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/to-update-notes`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNotesFiscalUpdate"));
    await api_get(url).then((resp) => {
      dispatch({
        type: GET_NOTES_FISCAL_UPDATE,
        payload: resp,
      });
    }).catch((error) => dispatch(setSnackbar(error ? error : "Error contacte al administrador")));
    dispatch(stopRequestComp("loadingNotesFiscalUpdate"));
  };
};

export const getNotesFiscalUpdate = (stationID, startDate, endDate) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/to-update-notes?station=${stationID}&start=${startDate}&end=${endDate}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNotesFiscalUpdate"));
    await api_get(url).then((resp) => {
      dispatch({
        type: GET_NOTES_FISCAL_UPDATE,
        payload: resp,
      });
    }).catch((error) => dispatch(setSnackbar(error)));
    dispatch(stopRequestComp("loadingNotesFiscalUpdate"));
  };
};

export const doNotesFiscalUpdate = (form, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/migrate-oracle/update-fiscal`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNotesFiscalUpdate"));
    await api_post(url, form).then((resp) => {
      dispatch({ type: DO_NOTES_FISCAL_UPDATE });
      dispatch({ type: DO_NOTES_MIGRATION, payload: resp });
      dispatch(setSnackbar("Actualización fiscal enviada", "success"));
      action && action();
    }).catch((error) => dispatch(setSnackbar(error ? error : "Error contacte al administrador")));
    dispatch(stopRequestComp("loadingNotesFiscalUpdate"));
  };
};

export const clearNotesFiscalUpdate = () => ({
  type: CLEAR_NOTES_FISCAL_UPDATE,
});

export const selectNoteToFiscalUpdate = (id) => ({
  type: SELECT_NOTE_TO_FISCAL_UPDATE,
  payload: id,
});

export const deselectNoteToFiscalUpdate = (id) => ({
  type: DESELECT_NOTE_TO_FISCAL_UPDATE,
  payload: id,
});

export const selectNextNotesFiscalUpdate = () => ({
  type: SELECT_NEXT_NOTES_FISCAL_UPDATE,
});

export const setNotesFiscalUpdateFilters = (key = "", data) => ({
  type: SET_NOTES_FISCAL_UPDATE_FILTERS,
  payload: { data, key },
});

export const setConfigPageNotesFiscalUpdate = (page) => ({
  type: SET_CONFIG_PAGE_NOTES_FISCAL_UPDATE,
  payload: page,
});

export const setConfigPageSizeNotesFiscalUpdate = (pageSize) => ({
  type: SET_CONFIG_PAGE_SIZE_NOTES_FISCAL_UPDATE,
  payload: pageSize,
});

export const setConfigFilterNotesFiscalUpdate = (filter) => ({
  type: SET_CONFIG_FILTER_NOTES_FISCAL_UPDATE,
  payload: filter,
});

export const setConfigSortedNotesFiscalUpdate = (sort) => ({
  type: SET_CONFIG_SORTED_NOTES_FISCAL_UPDATE,
  payload: sort,
});
